import { useCallback } from "react";
import useApi from "../../../utils/api";

// Every status except 401 comes back as a response, so the page can read the
// status code and the reason. 401 keeps the app's usual handling (token cleared, reload).
const validateStatus = (status) => status !== 401;

export const useHibobApi = () => {
	const { call } = useApi();

	const getStatus = useCallback(
		() =>
			call(
				{ method: "GET", url: "/integrations/hibob/status", validateStatus },
				true,
			),
		[call],
	);

	// The body must stay empty: the API rejects any field.
	const createSetupSession = useCallback(
		() =>
			call(
				{
					method: "POST",
					url: "/integrations/hibob/setup-sessions",
					data: {},
					validateStatus,
				},
				true,
			),
		[call],
	);

	// Sync now. Takes no input: the body stays empty.
	const startSync = useCallback(
		() =>
			call(
				{
					method: "POST",
					url: "/integrations/hibob/sync",
					data: {},
					validateStatus,
				},
				true,
			),
		[call],
	);

	// The API only accepts exactly this body.
	const disconnect = useCallback(
		() =>
			call(
				{
					method: "POST",
					url: "/integrations/hibob/disconnect",
					data: { confirm: "DISCONNECT" },
					validateStatus,
				},
				true,
			),
		[call],
	);

	// Time off to HiBob: Traxxion types, HiBob policy types, the saved mapping and suggestions.
	const getTimeoffMapping = useCallback(
		() => call({ method: "GET", url: "/integrations/hibob/timeoff-mapping", validateStatus }, true),
		[call],
	);

	// Exactly { mapping: { timeOffId: policyTypeName } }; an empty name unmaps the type.
	const saveTimeoffMapping = useCallback(
		(mapping) =>
			call(
				{ method: "PUT", url: "/integrations/hibob/timeoff-mapping", data: { mapping }, validateStatus },
				true,
			),
		[call],
	);

	return { getStatus, createSetupSession, startSync, disconnect, getTimeoffMapping, saveTimeoffMapping };
};
